import { Injectable } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'

import { GbBaseQuestion } from './gb-base-question'
import { FieldTypeEnum, StringMap } from 'libs/shared/models/shared.models'

@Injectable({
  providedIn: 'root',
})
export class GbQuestionControlService {
  toFormGroup(questions: GbBaseQuestion<string | boolean>[]): FormGroup {
    const group: StringMap<FormControl> = {}

    questions.forEach((question) => {
      const control =
        question.controlType === FieldTypeEnum.Checkbox
          ? this.getCheckboxFormControl(question as GbBaseQuestion<boolean>)
          : this.getDefaultFormControl(question as GbBaseQuestion<string>)

      group[question.key] = control
    })
    return new FormGroup(group)
  }

  getCheckboxFormControl(question: GbBaseQuestion<boolean>): FormControl<boolean> {
    const control: FormControl<boolean> = new FormControl(!!question.value, {
      nonNullable: true,
    })

    if (question.required) {
      control.setValidators(Validators.requiredTrue)
    }
    return control
  }

  getDefaultFormControl(question: GbBaseQuestion<string>): FormControl<string> {
    const control: FormControl<string> = new FormControl(question.value || '', {
      nonNullable: true,
    })

    if (question.required) {
      control.setValidators(Validators.required)
    }

    return control
  }
}
